var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMunhuoltoLogoTeksti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: #003c59;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 175.2,
    y1: 21,
    x2: 38.1,
    y2: 158.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8bdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 173.7,
    y1: 19.5,
    x2: 36.6,
    y2: 156.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 188,
    y1: 33.7,
    x2: 50.8,
    y2: 170.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 212,
    y1: 57.8,
    x2: 74.9,
    y2: 194.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 168.7,
    y1: 14.5,
    x2: 31.6,
    y2: 151.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 192.7,
    y1: 37.4,
    x2: 55.6,
    y2: 174.5,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.7,58.1c-1.1-1.1-2.5-1.7-4.1-1.7h-11.1l-7.4-7.4,10.9-10.9c5.1,1.8,11,.6,15-3.5,5.7-5.7,5.7-14.9,0-20.6-5.7-5.7-14.9-5.7-20.6,0s-5.2,10-3.5,15l-10.9,10.9-7.5-7.5v-11.2c0-1.5-.6-3-1.7-4.1l-8.4-8.4c-2.2-2.2-5.9-2.2-8.1,0s-2.2,5.9,0,8.1l6.7,6.7v5.5h-5.4l-2.6-2.6c-2.2-2.2-5.9-2.2-8.1,0s-2.2,5.9,0,8.1l4.3,4.3c1.1,1.1,2.5,1.7,4.1,1.7h11.2l7.5,7.5-10.5,10.5c-5.1-1.8-11-.6-15,3.5-5.7,5.7-5.7,14.9,0,20.6,5.7,5.7,14.9,5.7,20.6,0,4.1-4.1,5.2-10,3.5-15l10.5-10.5,7.4,7.4v12.8c0,1.5.6,3,1.7,4l8.8,8.8c1.1,1.1,2.6,1.7,4.1,1.7s2.9-.6,4.1-1.7c2.2-2.2,2.2-5.9,0-8.1l-7.1-7.1v-7.1s5.4,0,5.4,0l2.8,2.8c1.1,1.1,2.6,1.7,4.1,1.7s2.9-.6,4.1-1.7c2.2-2.2,2.2-5.9,0-8.1l-4.5-4.5ZM165.8,19.4c2.8-2.8,7.3-2.8,10,0,2.8,2.8,2.8,7.3,0,10-2.8,2.8-7.3,2.8-10,0-2.8-2.8-2.8-7.3,0-10ZM127.8,77.4c-2.8,2.8-7.3,2.8-10,0-2.8-2.8-2.8-7.3,0-10,2.8-2.8,7.3-2.8,10,0,2.8,2.8,2.8,7.3,0,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,101.2H57.6c-1.5,0-2.9-.7-3.8-2-.9-1.2-1.1-2.8-.6-4.2l7.9-21.7c2.6-7.3,9.6-12.2,17.4-12.2h19c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6h-19c-3.9,0-7.4,2.5-8.7,6.1l-5.7,15.6h87c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.3,99.5c-.8-2.4-3.3-3.8-5.7-3-2.4.8-3.8,3.3-3,5.7,2.5,7.9,3.7,16,3.7,24.3v14.5H38v-15.1c0-8.8,1.4-17.4,4.2-25.7l5.1-14.1c0,0,0-.1,0-.2l6.4-17.8c3.2-9,11.8-15,21.4-15h36.6c2.5,0,4.6-2.1,4.6-4.6s-2.1-4.6-4.6-4.6h-36.6c-13.4,0-25.4,8.5-30,21l-5.4,15h-11.4c-5,0-9.5,3.2-11.3,7.9-1.3,3.7-.8,7.8,1.4,11,2.2,3.2,5.9,5.1,9.8,5.1h3.2c-1.8,7.1-2.7,14.5-2.7,21.9v29.9c0,6.6,5.8,11.9,12.9,11.9h11c7.1,0,12.9-5.3,12.9-11.9v-5.6h77.2v5.6c0,6.6,5.8,11.9,12.9,11.9h11c7.1,0,12.9-5.3,12.9-11.9v-29.3c0-9.2-1.4-18.3-4.1-27ZM26.1,93.7c-.3-.4-.8-1.3-.3-2.6.4-1.1,1.5-1.9,2.6-1.9h8.1l-2,5.6h-6c-1.3,0-2.1-.8-2.3-1.2ZM56.4,155.8c0,1.5-1.7,2.7-3.7,2.7h-11c-2,0-3.7-1.2-3.7-2.7v-5.6h18.4v5.6ZM166.6,158.5h-11c-2,0-3.7-1.2-3.7-2.7v-5.6h18.4v5.6c0,1.5-1.7,2.7-3.7,2.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.4,135.6c-7.3,0-13.3-6-13.3-13.3s6-13.3,13.3-13.3,13.3,6,13.3,13.3-6,13.3-13.3,13.3ZM147.4,118.2c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1,4.1-1.8,4.1-4.1-1.8-4.1-4.1-4.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.9,135.6c-7.3,0-13.3-6-13.3-13.3s6-13.3,13.3-13.3,13.3,6,13.3,13.3-6,13.3-13.3,13.3ZM60.9,118.2c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1,4.1-1.8,4.1-4.1-1.8-4.1-4.1-4.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.2,134c-5.5,0-11-1.4-16.4-4.2-2.2-1.2-3.1-3.9-1.9-6.2,1.2-2.2,3.9-3.1,6.2-1.9,8.1,4.2,16.2,4.2,24.7,0,2.3-1.1,5-.2,6.1,2.1,1.1,2.3.2,5-2.1,6.1-5.6,2.8-11.2,4.2-16.7,4.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.5,151.2c-4.2,0-7.6-3.5-7.6-7.6v-63.8l-23.2,48.9c-1.4,3.2-4.2,4.8-7.4,4.8s-5.9-1.6-7.5-4.8l-23.1-48.9v63.9c0,4.2-3.5,7.5-7.6,7.5s-7.5-3.3-7.5-7.5V51c0-4.3,3.5-7.6,7.9-7.6s6.2,1.4,7.9,4.9l30,62.2,30.3-62.6c1.7-3.6,4.6-4.5,7.6-4.5,4.5,0,7.8,3.5,7.8,7.6v92.5c0,4.2-3.5,7.6-7.6,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M395.9,150.7c-2.6,0-5.9-1-8.4-3.2-1.6-1.3-2.7-2.9-3.6-4.8-5.1,5.1-12.1,7.9-21.8,7.9-17.6,0-24-11.1-24-26.7v-40.8c0-4.5,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1v39.1c0,8.1,2.2,13.3,11.8,13.3s11.8-3,14.7-7.9v-44.4c0-4.5,3.6-8.1,8.1-8.1s7.9,3.6,7.9,8.1v47.3c0,5.3,1.9,6.8,4.5,8.5,1.4,1,2.6,2.6,2.6,5.1,0,4.6-3.5,6.6-8.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M468,150.7c-4.5,0-7.9-3.6-7.9-7.9v-39.2c0-7.5-2.2-13.4-11.8-13.4s-12,3-14.9,7.6v45c0,4.3-3.6,7.9-8.1,7.9s-8.1-3.6-8.1-7.9v-46.6c0-5.3-1.7-6.8-4.3-8.5-1.4-1.2-2.6-2.7-2.6-4.9,0-4.8,3.5-6.8,8.1-6.8s5.8,1,8.4,3c1.4,1.2,2.5,2.7,3.3,4.3,5.1-5.2,12.3-8.2,22.1-8.2,18.2,0,24,11.1,24,26.7v41c0,4.3-3.6,7.9-8.1,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M543.3,150.7c-4.5,0-8.1-3.6-8.1-7.9v-39.2c0-7.5-2-13.3-11.8-13.3s-11.8,2.9-14.7,7.5v45c0,4.3-3.6,7.9-8.1,7.9s-8.1-3.6-8.1-7.9V53.3c0-4.3,3.8-7.9,8.1-7.9s8.1,3.6,8.1,7.9v27.6c4.5-3.8,10.7-5.8,18.6-5.8,18.3,0,24.1,11.1,24.1,26.7v41c0,4.3-3.6,7.9-8.1,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M625,150.7c-2.6,0-5.9-1-8.4-3.2-1.6-1.3-2.7-2.9-3.6-4.8-5.1,5.1-12.1,7.9-21.8,7.9-17.6,0-24-11.1-24-26.7v-40.8c0-4.5,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1v39.1c0,8.1,2.2,13.3,11.8,13.3s11.8-3,14.7-7.9v-44.4c0-4.5,3.6-8.1,8.1-8.1s7.9,3.6,7.9,8.1v47.3c0,5.3,1.9,6.8,4.5,8.5,1.4,1,2.6,2.6,2.6,5.1,0,4.6-3.5,6.6-8.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M671.7,150.7c-21.1,0-30-13.7-30-30.2v-15.2c0-16.6,8.9-30.3,30-30.3s30,13.7,30,30.3v15.2c0,16.4-9.1,30.2-30,30.2ZM671.7,136.1c9.7,0,14-5.9,14-15.7v-15c0-9.8-4.3-15.7-14-15.7s-14,5.9-14,15.7v15c0,9.8,4.2,15.7,14,15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M730.9,150.7c-2.6,0-5.9-1-8.4-3.2-4-3-6.6-8.2-6.6-15.2V53.3c0-4.3,3.6-7.9,7.9-7.9s8.1,3.6,8.1,7.9v77.2c0,5.3,1.9,6.8,4.5,8.5,1.4,1,2.5,2.6,2.5,5.1,0,4.6-3.3,6.6-7.9,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M785,149.9h-4.8c-20.5,0-26.8-13-26.8-32.3v-28.1h-3.2c-3.6,0-6.6-3-6.6-6.8s3-6.6,6.6-6.6h3.2v-12.4c0-4.5,3.8-8.1,8.1-8.1s8.1,3.6,8.1,8.1v12.4h12.1c3.8,0,6.8,2.9,6.8,6.6s-3,6.8-6.8,6.8h-12.1v27.8c0,13,2.3,18.3,12.7,18.3h2.7c3.9,0,7.2,3.2,7.2,7.1s-3.3,7.2-7.2,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M829.5,150.7c-21.1,0-30-13.7-30-30.2v-15.2c0-16.6,8.9-30.3,30-30.3s30,13.7,30,30.3v15.2c0,16.4-9.1,30.2-30,30.2ZM829.5,136.1c9.7,0,14-5.9,14-15.7v-15c0-9.8-4.3-15.7-14-15.7s-14,5.9-14,15.7v15c0,9.8,4.2,15.7,14,15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M882.7,151.3c-6.1,0-11-4.9-11-11s4.9-11,11-11,11,4.9,11,11-4.9,11-11,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M943,58.7h-4.2c-9.5,0-12.7,4-12.7,14.6v2.7h10.5c3.8,0,6.6,2.9,6.6,6.6s-2.9,6.8-6.6,6.8h-10.5v53.4c0,4.3-3.6,7.9-8.1,7.9s-8.1-3.6-8.1-7.9v-53.4h-3c-3.8,0-6.8-3-6.8-6.8s3-6.6,6.8-6.6h3v-2.7c0-17.9,7.8-28.9,27-28.9h6.1c3.9,0,7.2,3.2,7.2,7.1s-3.3,7.2-7.2,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M968,62.8c-5.2,0-9.4-4.2-9.4-9.4s4.2-9.4,9.4-9.4,9.4,4.2,9.4,9.4-4.2,9.4-9.4,9.4ZM959.9,83.2c0-4.5,3.8-8.1,8.1-8.1s8.1,3.6,8.1,8.1v59.6c0,4.3-3.6,7.9-8.1,7.9s-8.1-3.6-8.1-7.9v-59.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunhuoltoLogoTeksti);
export default __webpack_public_path__ + "static/media/Munhuolto_logo_teksti.a9d2ce1bae8ed4e4c0eb2634bc1fbefd.svg";
export { ForwardRef as ReactComponent };